import React from 'react';
import { motion } from 'framer-motion';
import { Heart, DollarSign, Sparkles } from 'lucide-react';
const benefits = [{
  icon: Heart,
  title: 'Aprendé algo lindo y útil',
  desc: 'Descubrí una actividad creativa, relajante y llena de posibilidades para hacer con tus propias manos.'
}, {
  icon: DollarSign,
  title: 'Generá ingresos extra desde casa',
  desc: 'Convertí tus creaciones en regalos, souvenirs o productos personalizados para vender.'
}, {
  icon: Sparkles,
  title: 'Empezá aunque seas principiante',
  desc: 'No necesitás experiencia previa. El kit está diseñado para guiarte paso a paso desde cero.'
}];
export function Benefits() {
  return <section className="py-12 sm:py-16 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-14">
      <div className="text-center max-w-3xl mx-auto mb-8 sm:mb-12 px-2" data-id="element-15">
        <h2 className="text-2xl sm:text-4xl lg:text-5xl text-brand-text mb-4 sm:mb-6 font-bold leading-tight" data-id="element-16">
          ¿Sentís que es momento de crear algo propio?
        </h2>
        <p className="text-base sm:text-lg text-brand-cta font-semibold" data-id="element-17">
          Con Deco Tricotín tenés todo lo que necesitás para empezar
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 sm:gap-6 lg:gap-8 max-w-5xl mx-auto" data-id="element-18">
        {benefits.map((benefit, i) => <motion.div key={i} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: i * 0.1
      }} className="bg-brand-card rounded-[2rem] p-6 sm:p-8 shadow-sm border border-brand-sand hover:shadow-md transition-shadow flex flex-col items-center text-center" data-id="element-19">
            <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-full bg-brand-sage/20 flex items-center justify-center mb-4 sm:mb-6 text-brand-olive" data-id="element-20">
              <benefit.icon size={28} className="sm:w-9 sm:h-9" strokeWidth={1.5} data-id="element-21" />
            </div>
            <h3 className="text-xl sm:text-2xl mb-2 sm:mb-4 text-brand-text font-serif font-bold leading-tight" data-id="element-22">
              {benefit.title}
            </h3>
            <p className="text-brand-text/70 leading-relaxed font-normal text-sm sm:text-base" data-id="element-23">
              {benefit.desc}
            </p>
          </motion.div>)}
      </div>
    </section>;
}